import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InnerImageZoom from 'react-inner-image-zoom';
import StandardModal from 'components/consumer/StandardModal';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import useKeyboardControlForIndexedItems from 'hooks/useKeyboardControlForIndexedItems';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import Prefetcher from 'components/essentials/Prefetcher';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import PDPDesktopFullScreenGallery2Thumbnail from './components/PDPDesktopFullScreenGallery2Thumbnail';
import usePhotoWidth from './usePhotoWidth';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
const PDPDesktopFullScreenGallery2UI = t0 => {
  const $ = _c(97);
  const {
    isEditOrder: t1,
    enableCrops,
    handleVideoSelected: t2,
    introVideoId: t3,
    isOpen,
    isVideoSelected: t4,
    onClose,
    photos: t5,
    photoSrc: t6,
    photosToPreload: t7,
    productName,
    selectedPhotoIndex,
    setSelectedPhotoIndex,
    videoThumbnailUrl
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const handleVideoSelected = t2 === undefined ? _temp : t2;
  const introVideoId = t3 === undefined ? "" : t3;
  const isVideoSelected = t4 === undefined ? false : t4;
  let t8;
  if ($[0] !== t5) {
    t8 = t5 === undefined ? [] : t5;
    $[0] = t5;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const photos = t8;
  let t9;
  if ($[2] !== t6) {
    t9 = t6 === undefined ? {} : t6;
    $[2] = t6;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const photoSrc = t9;
  let t10;
  if ($[4] !== t7) {
    t10 = t7 === undefined ? [] : t7;
    $[4] = t7;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const photosToPreload = t10;
  const thumbnailWrapperRef = useRef(null);
  const selectedThumbnailRef = useRef(null);
  let t11;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  const [items, setItems] = useState(t11);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  let t12;
  let t13;
  if ($[7] !== introVideoId || $[8] !== photos) {
    t12 = () => {
      const photoItems = photos.map(_temp2);
      const videoItem = {
        id: introVideoId,
        itemType: "video"
      };
      const updatedItems = introVideoId && photoItems.length ? [photoItems[0], videoItem, ...photoItems.slice(1)] : photoItems;
      setItems(updatedItems);
    };
    t13 = [photos, introVideoId];
    $[7] = introVideoId;
    $[8] = photos;
    $[9] = t12;
    $[10] = t13;
  } else {
    t12 = $[9];
    t13 = $[10];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[11] !== isVideoSelected || $[12] !== items || $[13] !== selectedPhotoIndex) {
    t14 = () => {
      if (isVideoSelected) {
        const videoItemIndex = items.findIndex(_temp3);
        if (videoItemIndex !== -1) {
          setSelectedItemIndex(videoItemIndex);
        }
      } else {
        const photoItemIndex = items.findIndex(item_0 => item_0.itemType === "photo" && item_0.photoIndex === selectedPhotoIndex);
        if (photoItemIndex !== -1) {
          setSelectedItemIndex(photoItemIndex);
        }
      }
    };
    t15 = [selectedPhotoIndex, items, isVideoSelected];
    $[11] = isVideoSelected;
    $[12] = items;
    $[13] = selectedPhotoIndex;
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  useEffect(t14, t15);
  let t16;
  if ($[16] !== handleVideoSelected || $[17] !== items || $[18] !== setSelectedPhotoIndex) {
    t16 = index_0 => {
      setIsZoomedIn(false);
      const updatedItem = items[index_0];
      if (updatedItem.itemType === "video") {
        handleVideoSelected(true);
      } else {
        handleVideoSelected(false);
        setSelectedPhotoIndex(updatedItem.photoIndex);
      }
      setTimeout(() => {
        const thumbnailWrapper = thumbnailWrapperRef?.current;
        const selectedThumbnail = selectedThumbnailRef?.current;
        thumbnailWrapper?.scrollTo({
          top: (selectedThumbnail?.offsetTop || 0) - (thumbnailWrapper.clientHeight || 64) / 2,
          behavior: "smooth"
        });
      }, 10);
    };
    $[16] = handleVideoSelected;
    $[17] = items;
    $[18] = setSelectedPhotoIndex;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const setSelectedItemAndScroll = t16;
  const numberOfItems = photos?.length ?? 0;
  let t17;
  if ($[20] !== isOpen || $[21] !== numberOfItems || $[22] !== selectedItemIndex || $[23] !== setSelectedItemAndScroll) {
    t17 = {
      isEnabled: isOpen,
      numberOfItems,
      selectedIndex: selectedItemIndex,
      setSelectedIndex: setSelectedItemAndScroll
    };
    $[20] = isOpen;
    $[21] = numberOfItems;
    $[22] = selectedItemIndex;
    $[23] = setSelectedItemAndScroll;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  useKeyboardControlForIndexedItems(t17);
  const maxPhotoWidth = usePhotoWidth();
  let t18;
  if ($[25] !== enableCrops || $[26] !== items || $[27] !== selectedItemIndex || $[28] !== setSelectedItemAndScroll || $[29] !== videoThumbnailUrl) {
    t18 = items.map((t19, itemIndex) => {
      const {
        cropData,
        type,
        id,
        itemType,
        src
      } = t19;
      const isItemSelected = itemIndex === selectedItemIndex;
      return <PDPDesktopFullScreenGallery2Thumbnail cropData={cropData} enableCrops={enableCrops} isItemSelected={isItemSelected} itemIndex={itemIndex} itemType={itemType} key={`${id}-${itemType}`} selectedThumbnailRef={selectedThumbnailRef} setSelectedItemAndScroll={setSelectedItemAndScroll} src={src} type={type} videoThumbnailUrl={videoThumbnailUrl} />;
    });
    $[25] = enableCrops;
    $[26] = items;
    $[27] = selectedItemIndex;
    $[28] = setSelectedItemAndScroll;
    $[29] = videoThumbnailUrl;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18) {
    t19 = <div className="max-h-[calc(90vh_-_4rem)] min-w-[315px] overflow-y-auto w-[325px]" ref={thumbnailWrapperRef}><div className="grid gap-[7px_7px] grid-cols-[142px_142px] mb-px min-w-[300px] w-1/4">{t18}</div></div>;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== maxPhotoWidth) {
    t20 = {
      maxWidth: maxPhotoWidth
    };
    $[33] = maxPhotoWidth;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== productName) {
    t21 = <div className="text-xl font-bold text-gray mb-4 max-w-full text-center w-[2000px]">{productName}</div>;
    $[35] = productName;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== isVideoSelected) {
    t22 = classNames("object-contain object-center select-none p-0 max-w-full relative flex", {
      "w-full": isVideoSelected
    });
    $[37] = isVideoSelected;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== isZoomedIn) {
    t23 = classNames("items-center border-0 bottom-0 flex justify-start opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(90deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] left-0  h-full", {
      hidden: isZoomedIn
    });
    $[39] = isZoomedIn;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== numberOfItems || $[42] !== selectedItemIndex || $[43] !== setSelectedItemAndScroll) {
    t24 = () => {
      const previousIndex = selectedItemIndex - 1;
      if (previousIndex < 0) {
        setSelectedItemAndScroll(numberOfItems - 1);
      } else {
        setSelectedItemAndScroll(previousIndex);
      }
    };
    $[41] = numberOfItems;
    $[42] = selectedItemIndex;
    $[43] = setSelectedItemAndScroll;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconArrowRightSimple width={22} height={40} className="ml-2.5 -rotate-180" color="white" />;
    t26 = <VisuallyHidden>Previous image</VisuallyHidden>;
    $[45] = t25;
    $[46] = t26;
  } else {
    t25 = $[45];
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t23 || $[48] !== t24) {
    t27 = <button type="button" className={t23} onClick={t24}>{t25}{t26}</button>;
    $[47] = t23;
    $[48] = t24;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== isVideoSelected || $[51] !== photoSrc) {
    t28 = !isVideoSelected && photoSrc?.zoomSrc ? <InnerImageZoom height={600} src={photoSrc.src} zoomSrc={photoSrc.zoomSrc} zoomPreload={true} hasSpacer={true} hideCloseButton={true} hideHint={true} afterZoomIn={() => {
      setIsZoomedIn(true);
    }} afterZoomOut={() => {
      setIsZoomedIn(false);
    }} /> : null;
    $[50] = isVideoSelected;
    $[51] = photoSrc;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== introVideoId || $[54] !== isVideoSelected) {
    t29 = isVideoSelected && introVideoId ? <PDPProductIntroVideo variant="PDPDesktopFullScreenGallery2" videoId={introVideoId} /> : null;
    $[53] = introVideoId;
    $[54] = isVideoSelected;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== isZoomedIn) {
    t30 = classNames("items-center border-0 bottom-0 flex opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(270deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] justify-end right-0 h-full", {
      hidden: isZoomedIn
    });
    $[56] = isZoomedIn;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== numberOfItems || $[59] !== selectedItemIndex || $[60] !== setSelectedItemAndScroll) {
    t31 = () => {
      const nextIndex = selectedItemIndex + 1;
      if (nextIndex >= numberOfItems) {
        setSelectedItemAndScroll(0);
      } else {
        setSelectedItemAndScroll(nextIndex);
      }
    };
    $[58] = numberOfItems;
    $[59] = selectedItemIndex;
    $[60] = setSelectedItemAndScroll;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  let t33;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <IconArrowRightSimple width={22} height={40} className="mr-2.5" color="white" />;
    t33 = <VisuallyHidden>Next image</VisuallyHidden>;
    $[62] = t32;
    $[63] = t33;
  } else {
    t32 = $[62];
    t33 = $[63];
  }
  let t34;
  if ($[64] !== t30 || $[65] !== t31) {
    t34 = <button type="button" className={t30} onClick={t31}>{t32}{t33}</button>;
    $[64] = t30;
    $[65] = t31;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t22 || $[68] !== t27 || $[69] !== t28 || $[70] !== t29 || $[71] !== t34) {
    t35 = <div className={t22}>{t27}{t28}{t29}{t34}</div>;
    $[67] = t22;
    $[68] = t27;
    $[69] = t28;
    $[70] = t29;
    $[71] = t34;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  let t36;
  if ($[73] !== isEditOrder || $[74] !== isVideoSelected || $[75] !== onClose || $[76] !== photos || $[77] !== productName || $[78] !== selectedPhotoIndex) {
    t36 = !isVideoSelected && <div className="flex-[1_1] flex items-center justify-end"><div className="PDPDesktopFullScreenGallery2__MainPhoto-shownin"><PDPShownIn fullWidth={true} isEditOrder={isEditOrder} optionId={photos?.[selectedPhotoIndex]?.optionId} valueId={photos?.[selectedPhotoIndex]?.valueId} upholsteryName={photos?.[selectedPhotoIndex]?.upholsteryName} onSelection={() => {
          onClose(true);
        }} layout="greyBG" showInactiveUpholstery={true} productName={productName} /></div></div>;
    $[73] = isEditOrder;
    $[74] = isVideoSelected;
    $[75] = onClose;
    $[76] = photos;
    $[77] = productName;
    $[78] = selectedPhotoIndex;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== t36) {
    t37 = <div className="flex flex-row mt-4 w-full">{t36}</div>;
    $[80] = t36;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t20 || $[83] !== t21 || $[84] !== t35 || $[85] !== t37) {
    t38 = <div className="items-center flex flex-col ml-6"><div className="items-center bg-transparent border-0 flex flex-col flex-1 justify-between max-h-[calc(90vh_-_4rem)] overflow-y-hidden" style={t20}>{t21}{t35}{t37}</div></div>;
    $[82] = t20;
    $[83] = t21;
    $[84] = t35;
    $[85] = t37;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== t19 || $[88] !== t38) {
    t39 = <div className="flex flex-row justify-center w-full">{t19}{t38}</div>;
    $[87] = t19;
    $[88] = t38;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== isOpen || $[91] !== onClose || $[92] !== t39) {
    t40 = <StandardModal isOpen={isOpen} onClose={onClose} theme="light" size="xl">{t39}</StandardModal>;
    $[90] = isOpen;
    $[91] = onClose;
    $[92] = t39;
    $[93] = t40;
  } else {
    t40 = $[93];
  }
  let t41;
  if ($[94] !== photosToPreload || $[95] !== t40) {
    t41 = <div className="w-full"><Prefetcher onRenderAssets={photosToPreload}>{t40}</Prefetcher></div>;
    $[94] = photosToPreload;
    $[95] = t40;
    $[96] = t41;
  } else {
    t41 = $[96];
  }
  return t41;
};
PDPDesktopFullScreenGallery2UI.propTypes = {
  enableCrops: PropTypes.bool,
  handleVideoSelected: PropTypes.func,
  introVideoId: PropTypes.string,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  isVideoSelected: PropTypes.bool,
  onClose: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    cropData: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    optionId: PropTypes.number,
    src: PropTypes.string,
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'dimensional', 'studio']),
    upholsteryName: PropTypes.string,
    valueId: PropTypes.number
  })),
  photoSrc: PropTypes.shape({
    src: PropTypes.string,
    zoomSrc: PropTypes.string
  }),
  photosToPreload: PropTypes.arrayOf(PropTypes.string),
  productName: PropTypes.string,
  selectedPhotoIndex: PropTypes.number,
  setSelectedPhotoIndex: PropTypes.func,
  videoThumbnailUrl: PropTypes.string
};
export default PDPDesktopFullScreenGallery2UI;
function _temp() {}
function _temp2(photo, index) {
  return {
    cropData: photo.cropData,
    type: photo.type,
    id: photo.id,
    itemType: "photo",
    optionId: photo.optionId,
    photoIndex: index,
    src: photo.src,
    upholsteryName: photo.upholsteryName,
    valueId: photo.valueId
  };
}
function _temp3(item) {
  return item.itemType === "video";
}